import { objectWithoutKeys } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { LoadEcsTreatmentsFulfilledAction } from '../../domains/ecs/actions.types';
import {
  FeatureRolloutAddOverrideAction,
  FeatureRolloutRemoveAllOverridesAction,
  FeatureRolloutRemoveOverrideAction,
} from '../../domains/featureRollouts/actions.types';

import { EcsFeatureRollouts, defaultFeatureRolloutTreatments } from './types';

export type FeatureRolloutAction =
  | LoadEcsTreatmentsFulfilledAction
  | FeatureRolloutAddOverrideAction
  | FeatureRolloutRemoveOverrideAction
  | FeatureRolloutRemoveAllOverridesAction;

const initialState: EcsFeatureRollouts = {
  treatments: defaultFeatureRolloutTreatments,
  treatmentsFromService: {},
  treatmentOverrides: {},
};

const reducer: Reducer<EcsFeatureRollouts, FeatureRolloutAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'FEATURE_FLIGHTING.LOAD_ECS_TREATMENTS_FULFILLED':
      return {
        ...state,
        treatments: {
          ...defaultFeatureRolloutTreatments,
          ...action.payload.ecsFeatureRolloutTreatments,
          ...state.treatmentOverrides,
        },
        treatmentsFromService: action.payload.ecsFeatureRolloutTreatments,
      };
    case 'FEATURE_FLIGHTING.FEATURE_ROLLOUT_ADD_OVERRIDE': {
      const rollout = action.payload.featureRollout;
      const enabled = action.payload.enabled;

      return {
        ...state,
        treatments: {
          ...state.treatments,
          [rollout]: enabled,
        },
        treatmentOverrides: {
          ...state.treatmentOverrides,
          [rollout]: enabled,
        },
      };
    }

    case 'FEATURE_FLIGHTING.FEATURE_ROLLOUT_REMOVE_OVERRIDE': {
      const featureRollout = action.payload.featureRollout;
      const restoredValue =
        state.treatmentsFromService[featureRollout] ?? defaultFeatureRolloutTreatments[featureRollout];
      const remainingOverrides = objectWithoutKeys(state.treatmentOverrides, [featureRollout]);

      return {
        ...state,
        treatments: {
          ...state.treatments,
          [featureRollout]: restoredValue,
        },
        treatmentOverrides: remainingOverrides,
      };
    }

    case 'FEATURE_FLIGHTING.FEATURE_ROLLOUT_REMOVE_ALL_OVERRIDES':
      return {
        ...state,
        treatments: {
          ...defaultFeatureRolloutTreatments,
          ...state.treatmentsFromService,
        },
        treatmentOverrides: {},
      };
    default:
      return state;
  }
};

export default reducer;
